import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconSearch = ({
  title = "Search",
  color = "black",
  viewBoxWidth = 16,
  viewBoxHeight = 16,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="Search" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle
        stroke={uiColorToBaseColor(color)}
        strokeWidth="2"
        cx="6.5"
        cy="6.5"
        r="5.5"
      />
      <path
        d="M9.5,11.0146355 L11,9.5 L15.2928932,13.7928932 C15.6834175,14.1834175 15.6834175,14.8165825 15.2928932,15.2071068 L15.2060711,15.2939289 C14.8159515,15.6840485 14.1835857,15.6845119 13.7928947,15.2949645 L9.5,11.0146355 L9.5,11.0146355 Z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconSearch
